module.exports = __webpack_public_path__ + "static/media/mockup.d281eae3.webp";